import React, { useState } from 'react';
import './SportMentalTestsScreen.css';
import { useNavigate } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';
import logoImage from '../../resources/1000028180.jpeg';

export default function SportMentalTestsScreen() {
  const [activeTest, setActiveTest] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
  const [showArabicInstruction, setShowArabicInstruction] = useState(false);
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  console.log("Active Test:", activeTest);

  const handleMenuClick = () => setShowMenu((prev) => !prev);
  const handleProfile = () => {
    setShowMenu(false);
    navigate('/profile');
  };
  const handleLogout = () => {
    setShowMenu(false);
    navigate("/logout");
  };

  const handleTestClick = (test) => {
    // Toggle: if the same test is clicked again, hide it
    setActiveTest(prev => (prev === test ? null : test));
  };

  const renderTestContent = () => {
    switch (activeTest) {
      case 'MTT-20':
        return {
          title: 'MTT-20 Assessment',
          description: (
            <>
              <div style={{marginBottom: 16 , fontSize: '1rem', fontFamily: 'Poppins, sans-serif'}}>
                Welcome to the Mental Toughness Assessment!<br/>
                This test will evaluate your mental toughness across four key areas:
                <ul className="popup-list" style={{margin: '12px 0 0 24px', fontFamily: 'Poppins, sans-serif'}}>
                  <li>Challenge</li>
                  <li>Commitment</li>
                  <li>Control</li>
                  <li>Confidence</li>
                </ul>
              </div>
              <div style={{marginBottom: 8, fontWeight: 500, fontSize: '1rem' , fontFamily: 'Poppins, sans-serif'}}>Instructions:</div>
              <ol style={{marginLeft: 24, fontSize: '14px', listStyleType: 'decimal' , fontFamily: 'Poppins, sans-serif'}}>
                <li>Rate each statement on a scale of 1 (Strongly Disagree) to 5 (Strongly Agree)</li>
                <li>Answer honestly based on how you typically feel and behave</li>
                <li>Complete all questions for accurate results</li>
              </ol>
            </>
          ),
          onStart: () => navigate('/MTT20ChallengePage')
        };
      case 'PAT-10':
        return {
          title: 'PAT-10 Assessment',
          description: (
            <>
              <div style={{marginBottom: 16 , fontSize: '1rem' , fontFamily: 'Poppins, sans-serif'}}>
                Welcome to the Cognitive Anxiety Assessment!<br/>
                This test evaluates your mental worries and self-doubt before competition.
              </div>
              <div style={{marginBottom: 8, fontWeight: 500 , fontSize: '1rem' , fontFamily: 'Poppins, sans-serif'}}>Instructions:</div>
              <ol style={{marginLeft: 24 , fontSize: '14px', listStyleType: 'decimal' , fontFamily: 'Poppins, sans-serif'}}>
                <li>Rate each statement on a scale of 1 (Strongly Disagree) to 5 (Strongly Agree)</li>
                <li>Answer honestly based on your usual thoughts and emotions before competing</li>
                <li>Complete all questions to ensure a full picture of your cognitive anxiety</li>
              </ol>
            </>
          ),
          onStart: () => navigate('/Cognitive')
        };
      case 'SMA U10':
        return {
          title: 'SMA U10 Assessment',
          description: (
            <>
              <div style={{marginBottom: 16 , fontSize: '1rem' , fontFamily: 'Poppins, sans-serif'}}>
                {/* Welcome Young Athlete! 🌟<br/> */}
                This fun quiz will help us understand how you feel during sports!
                <ul style={{margin: '12px 0 0 24px' , fontSize: '1rem' , fontFamily: 'Poppins, sans-serif'}}>
                  <li>How you handle challenges</li>
                  <li>How you stay focused</li>
                  <li>How confident you feel</li>
                  <li>How you handle nervous feelings</li>
                </ul>
              </div>
              <div style={{marginBottom: 8, fontWeight: 500, fontSize: '1rem' , fontFamily: 'Poppins, sans-serif'}}>Instructions:</div>
              <ul style={{marginLeft: 24, fontSize: '14px' , fontFamily: 'Poppins, sans-serif'}}>
                <li>1 = No, not really</li>
                <li>2 = Sometimes</li>
                <li>3 = Yes, a lot</li>
              </ul>
              {/* <div style={{marginTop: 8}}>Ask your coach or parent if you need help understanding any questions!</div> */}
            </>
          ),
          onStart: () => navigate('/Handling')
        };
      case 'SMFT-30':
        return {
          title: 'SMFT-30 Assessment',
          description: (
            <>
              <div style={{marginBottom: 16 , fontSize: '1rem' , fontFamily: 'Poppins, sans-serif'}}>
                This test covers different psychological aspects of athletic performance.
              </div>
              <div style={{marginBottom: 8, fontWeight: 500, fontSize: '1rem' , fontFamily: 'Poppins, sans-serif'}}>Instructions:</div>
              <ul style={{marginLeft: 24 , fontSize: '14px' , listStyleType: 'decimal' , fontFamily: 'Poppins, sans-serif'}}>
                <li>Answer each section honestly</li>
                <li>Complete all questions for best results</li>
              </ul>
            </>
          ),
          onStart: () => navigate('/Resilience')
        };
      default:
        return null;
    }
  };

  const testModalContent = activeTest ? renderTestContent() : null;

  return (
    <div className="dashboard-container">
      {/* Header */}
      <header className="dashboard-header">
        <div className="header-content">
          <div className="header-logo-container">
                                  <img
                        src={logoImage}
                        alt="Power Mind Metrics Logo"
                        style={{ height: "90px", width: "100px", marginRight: "10px" }}
                      />
            <h1 className="header-logo" style={{ whiteSpace: window.innerWidth <= 600 ? 'nowrap' : undefined, fontSize: window.innerWidth <= 600 ? 22 : undefined }}>Power Mind Metrics</h1>
          </div>
          <nav className="header-nav desktop-nav">
            <button className="nav-link" onClick={handleProfile}>Profile</button>
            <button className="nav-link" onClick={handleLogout}>Logout</button>
          </nav>
          <div className="mobile-nav-menu">
            <button className="hamburger-btn" onClick={() => setMobileMenuOpen(v => !v)}>
              <FiMenu size={28} />
            </button>
            {mobileMenuOpen && (
              <div className="mobile-nav-dropdown">
                <button className="nav-link" onClick={() => { setMobileMenuOpen(false); handleProfile(); }}>Profile</button>
                <button className="nav-link" onClick={() => { setMobileMenuOpen(false); handleLogout(); }}>Logout</button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="dashboard-main" >
        <div className="dashboard-card">
        <h2 className="main-title">Sport Mental Tests</h2>
          {/* Intro Section */}
          <div className="intro-section">
         
            <p className="welcome-text"></p>
            <p className="intro-description">
            Welcome, Athlete!<br/>
            These tests are designed to provide you with an opportunity for self-reflection on various aspects of your sport mental fitness. The purpose of these tests is to help you gain insights into your sport mental well being , fostering greater understanding of your strengths and areas that may benefit from attention. It is essential to note that this test scoring results are not a diagnostic tool and its primary aim is to encourage self awareness. Please keep in mind that these tests and its scoring results is not a substitute for any diagnosis , it is only a starting point of your self reflection.
            </p>
            {/* <ul className="benefits-list">
              <li>Gauge your stress, focus, resilience and recovery</li>
              <li>Highlight strengths and areas to sharpen</li>
              <li>Guide your next mental-fitness moves</li>
              <li className="list-none">⚠️ For self-reflection only—not a clinical diagnosis. Use these insights as your starting point.</li>
            </ul> */}
            {/* <div style={{ marginBottom: '10px'}}>
          ⚠️ For self-reflection only—not a clinical diagnosis. Use these insights as your starting point.
            </div> */}
            {/* <div className="disclaimer"> */}
              {/* <span className="warning-icon">⚠️</span>
              <span className="disclaimer-text">
                For self-reflection only—not a clinical diagnosis. Use these insights as your starting point.
              </span> */}
            {/* </div> */}
          </div>

          {/* Assessment Cards Grid */}
          <div className="grid grid-flow-row grid-cols-2 gap-4">
            <div className="assessment-card">
              <h3 className="card-title">MTT-20 (Mental Toughness Test)</h3>
              <p className="card-description">
                It evaluates an athletes psychological resilience across four key dimensions.
              </p>
              <button 
                className="card-start-btn"
                onClick={() => setActiveTest('MTT-20')}
                style={{fontFamily: 'Poppins, sans-serif'}}
              >
                Start
              </button>
            </div>

            <div className="assessment-card">
              <h3 className="card-title">PAT-10 (Performance Anxiety Test)</h3>
              <p className="card-description">
                A focused assessment of pre-competition anxiety and mental state before athletic performance.
              </p>
              <button 
                className="card-start-btn"
                onClick={() => setActiveTest('PAT-10')}
                style={{fontFamily: 'Poppins, sans-serif'}}
              >
                Start
              </button>
            </div>

            <div className="assessment-card">
              <h3 className="card-title">SMA U10 (Sport Mental Assessment)</h3>
              <p className="card-description">
                It is designed specifically for athletes.
              </p>
              <button 
                className="card-start-btn"
                onClick={() => setActiveTest('SMA U10')}
                style={{fontFamily: 'Poppins, sans-serif'}}
              >
                Start
              </button>
            </div>

            <div className="assessment-card">
              <h3 className="card-title">SMFT-30 (Sport Mental Fitness Test)</h3>
              <p className="card-description">
                It covers different psychological aspects of athletic performance.
              </p>
              <button 
                className="card-start-btn"
                onClick={() => setActiveTest('SMFT-30')}
                style={{fontFamily: 'Poppins, sans-serif'}}
              >
                Start
              </button>
            </div>

            <div className="assessment-card" style={{ direction: 'rtl', fontFamily: ' Poppins,  sans-serif', marginBottom: 32 }}>
              <div className="card-title" style={{ fontSize: 22, fontWeight: 700, color: '#11998e', marginBottom: 12 }}>اختبار اللياقة العقلية الرياضية SMFT-30 (Arabic)</div>
              <p className="card-description" style={{ textAlign: 'right' }}>ويغطي الجوانب النفسية المختلفة للأداء الرياضي.</p>
              <button
                className="card-start-btn"
                onClick={() => navigate('/smft-arabic')}
                style={{fontFamily: 'Poppins, sans-serif'}}
              >
              يبدأ
              </button>
            </div>

            <div className="assessment-card" style={{ direction: 'rtl', fontFamily: ' Poppins,  sans-serif', marginBottom: 32 }}>
              <div className="card-title" style={{ fontSize: 22, fontWeight: 700, color: '#11998e', marginBottom: 12 }}>اختبار القلق والأداء الرياضي PAT-10 (Arabic)</div>
              <p className="card-description" style={{ textAlign: 'right' }}>يقيم القلق المعرفي والجسدي والثقة بالنفس قبل المنافسة.</p>
              <button
                className="card-start-btn"
                onClick={() => navigate('/pat-arabic')}
                style={{fontFamily: 'Poppins, sans-serif'}}
              >
                يبدأ
              </button>
            </div>

            <div className="assessment-card" style={{ direction: 'rtl', fontFamily: ' Poppins,  sans-serif', marginBottom: 32 }}>
              <div className="card-title" style={{ fontSize: 22, fontWeight: 700, color: '#11998e', marginBottom: 12 }}>اختبار ذهني مخصص لفئة تحت 10 سنوات SMA U10 (Arabic)</div>
              <p className="card-description" style={{ textAlign: 'right' }}>اختبار مخصص للأطفال تحت سن 10 سنوات لقياس التعامل مع التحديات والتركيز والثقة.</p>
              <button
                className="card-start-btn"
                onClick={() => navigate('/sma-arabic')}
                style={{fontFamily: 'Poppins, sans-serif'}}
              >
                يبدأ
              </button>
            </div>

            <div className="assessment-card" style={{ direction: 'rtl', fontFamily: ' Poppins,  sans-serif', marginBottom: 32 }}>
              <div className="card-title" style={{ fontSize: 22, fontWeight: 700, color: '#11998e', marginBottom: 12 }}>اختبار الصلابة الذهنية MTT-20 (Arabic)</div>
              <p className="card-description" style={{ textAlign: 'right' }}>يقيس الصلابة الذهنية في الرياضة عبر أربعة أبعاد: التحدي والالتزام والسيطرة والثقة.</p>
              <button
                className="card-start-btn"
                onClick={() => navigate('/mtt-arabic')}
                style={{fontFamily: 'Poppins, sans-serif'}}
              >
                يبدأ
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* Test Content Modal */}
      {activeTest && testModalContent && (
        <div className="test-modal-overlay" style={{zIndex: 1000}}>
          <div className="test-modal" style={{
            maxWidth: 600,
            width: '90%',
            background: '#fff',
            borderRadius: 16,
            boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            padding: '3.5rem 2.5rem 2rem 2.5rem', // Increased top padding
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
          }}>
            <h2 style={{fontWeight: 700, fontSize: 28, textAlign: 'center', marginBottom: 24, color: '#444', fontFamily: 'Poppins, sans-serif'}}>{testModalContent.title}</h2>
            <div style={{fontSize: 18, color: '#444', marginBottom: 32, fontFamily: 'Poppins, sans-serif', textAlign: 'left', width: '100%'}}>
              {testModalContent.description}
            </div>
            <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', marginTop: 16, gap: 16}}>
              <button
                onClick={() => setActiveTest(null)}
                style={{
                  width: 107,
                  height: 40,
                  borderRadius: 8,
                  border: '2px solid #2aa7a1',
                  background: '#fff',
                  color: '#2aa7a1',
                  fontWeight: 400,
                  fontSize: 15,
                  fontFamily: 'Poppins, sans-serif',
                  cursor: 'pointer',
                  transition: 'background 0.2s, color 0.2s',
                }}
              >
                Back
              </button>
              <button
                onClick={testModalContent.onStart}
                style={{
                  width: 107,
                  height: 40,
                  borderRadius: 8,
                  border: 'none',
                  background: '#2aa7a1',
                  color: '#fff',
                  fontWeight: 400,
                  fontSize: 15,
                  fontFamily: 'Poppins, sans-serif',
                  cursor: 'pointer',
                  transition: 'background 0.2s',
                }}
              >
                Start
              </button>
            </div>
          </div>
        </div>
      )}
      {showArabicInstruction && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.18)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 16,
            boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            padding: '2.5rem 2.5rem 2rem 2.5rem',
            minWidth: 340,
            maxWidth: 500,
            textAlign: 'right',
            fontFamily: 'Cairo, Poppins, Segoe UI, sans-serif',
            direction: 'rtl',
          }}>
            <h2 style={{ color: '#11998e', fontWeight: 700, fontSize: 24, marginBottom: 12, textAlign: 'center' }}>تعليمات الاختبار</h2>
            <div style={{ color: '#444', fontSize: 18, marginBottom: 18, whiteSpace: 'pre-line', lineHeight: 2 }}>
              عزيزي اللاعب،
              <br />
              شكرًا لك على تخصيص الوقت للمشاركة في اختبار اللياقة الذهنية.
              <br />
              تهدف نتائج هذا الاختبار إلى إتاحة فرصة للتفكير الذاتي حول مختلف جوانب لياقتك الذهنية.
              <br />
              الغرض من هذه النتائج هو مساعدتك على اكتساب فهم أعمق لحالتك الذهنية، وتعزيز إدراكك لنقاط قوتك والمجالات التي قد تحتاج إلى اهتمام. من المهم أن تعلم أن نتائج هذا الاختبار ليست أداة تشخيصية، وهدفها الأساسي هو تشجيع الوعي الذاتي.
              <br />
              يرجى الأخذ في الاعتبار أن نتائج هذا الاختبار لا تُعد بديلاً عن أي تشخيص طبي، وإنما تُعد نقطة انطلاق للتفكير الذاتي..
            </div>
            <button
              className="card-start-btn"
              style={{ background: '#11998e', color: '#fff', fontWeight: 600, fontSize: 18, borderRadius: 8, marginTop: 12, width: '100%' }}
              onClick={() => { setShowArabicInstruction(false); navigate('/Adaptability'); }}
            >
              متابعة
            </button>
          </div>
        </div>
      )}
      
      {/* Footer */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '12px 0',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
        zIndex: 100,
        // marginTop: 100
      }}>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: 'rgba(75, 75, 75, 0.8)',
          fontWeight: 400
        }}>
          © 2025 All rights reserved Power Mind Metrics
        </p>
      </div>
    </div>
  );
}
